import { useContext } from 'react';
import { changeWebPageTitleService } from '../../../../infrastructure/services';
import {
    ChangePasswordController,
    CompanyController,
    PasswordPoliciesController,
} from '../controllers';
import { ProfileContainer } from '../components';
import { AppContext } from '../../../../main/context/Provider';

const ProfilePage = () => {
    const { langResources, isSkinSmart, userInfo } = useContext(AppContext);

    const { webPage } = changeWebPageTitleService(
        isSkinSmart,
        langResources['profile.page']['title.web.page']
    );

    //const { companies } = CompanyController(userInfo.id);
    const { passwordPolicies } = PasswordPoliciesController();

    const {
        confirmPassword,
        changeSuccessfully,
        newPassword,
        sendChange,
        handlerSavePassword,
        handlerChangeConfirmPassword,
        currentPassword,
        handlerChangecurrentPassword,
        handlerChangeNewPassword,
    } = ChangePasswordController(passwordPolicies);

    console.log(userInfo);

    return (
        <div className='main-content'>
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row mt-4'>
                        <div className='col-lg-3'>
                            <div className='card '>
                                <div className='card-body'>
                                    <div className='text-center'>
                                        <div className='profile-user position-relative d-inline-block mx-auto  mb-4'>
                                            <img
                                                src='/assets/images/user-dummy-img.jpg'
                                                className='rounded-circle avatar-xl img-thumbnail user-profile-image'
                                                alt='user-profile'
                                            />
                                        </div>

                                        <h5
                                            className={`fs-16 mb-1 text-primary2 fw-bolder`}
                                        >
                                            {userInfo.firstName}
                                        </h5>
                                        <p className='text-muted mb-0'>
                                            {userInfo.email}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ProfileContainer
                            confirmPassword={confirmPassword}
                            newPassword={newPassword}
                            currentPassword={currentPassword}
                            isSendChange={sendChange}
                            //companiesList={companies}
                            passwordPoliciesList={passwordPolicies}
                            isChangeSuccessfully={changeSuccessfully}
                            changeConfirmPassword={handlerChangeConfirmPassword}
                            changeNewPassword={handlerChangeNewPassword}
                            changeCurrentPassword={handlerChangecurrentPassword}
                            savePassword={handlerSavePassword}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
